import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const devopsConnectedProjectRoute: InvariantJiraRoute = {
	name: 'devops-connected-project',
	path: '/jira/devops/connected-project',
};
